import { Injectable } from '@angular/core';
import { ApiConfigService } from '../../../shared-services/api-config.service';

@Injectable({
  providedIn: 'root'
})
export class MonumentEntityService {

  constructor(private apiConfigService:ApiConfigService) { }

  saveToBackend(monumentDto){
    return this.apiConfigService.post('api/monument/create',monumentDto);
  }
}
